<ng-container *ngFor="let item of collapsibleNavItems">
  <acl-ngx-collapsible-nav-item [icon]="item.icon" [label]="item.label" [title]="item.title" [active]="item.active"
    [linkProps]="item.linkProps" [childItems]="item.children">
  </acl-ngx-collapsible-nav-item>
</ng-container>